import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { GraduationCapIcon } from 'lucide-react';
import { AcademyProvider, useAcademy } from '../../context/Academy';
import { AcademyHubProvider, useAcademyHub } from '../../context/AcademyHub';
import { Container } from '../ui/Primitives';
import { NotificationMenu } from './NotificationMenu';
import { SupportChat } from './SupportChat';
import { OnboardingDialog } from './OnboardingDialog';
export function AcademyLayout() {
  return <AcademyProvider data-id="element-109" data-mp="1t24hm18o2ce">
      <AcademyHubProvider data-id="element-110" data-mp="1s93z2svi92p">
        <AcademyBar data-id="element-111" data-mp="1rh6tnjmo3ab" />
        <Outlet data-id="element-112" data-mp="1v532uggj3sq" />
        <SupportChat data-id="element-113" data-mp="6soeznpon4hi" />
        <OnboardingDialog data-id="element-114" data-mp="6s58d35hg2is" />
      </AcademyHubProvider>
    </AcademyProvider>;
}
function AcademyBar() {
  const {
    state
  } = useAcademy();
  const {
    role,
    staff,
    hub
  } = useAcademyHub();
  const unreadMessages = state.learner ? hub.messages.filter(m => m.learnerEmail === state.learner?.email && m.from === 'staff' && !m.read).length : 0;
  const linkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `relative flex shrink-0 items-center gap-1.5 border-b-2 py-4 text-[14px] transition-colors duration-150 ${isActive ? 'border-gold text-ink' : 'border-transparent text-body hover:text-ink'}`;
  return <div className="mt-4 border-b border-line" data-id="element-115" data-mp="nhrs0un33e55">
      <Container className="flex items-center gap-6" data-id="element-116" data-mp="iif9gm38wt8d">
        <span className="hidden shrink-0 items-center gap-2 py-4 font-display text-[15px] text-ink md:flex" data-id="element-117" data-mp="ik02u8dtq64n">
          <GraduationCapIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-118" data-mp="1g3ur19k0pw62" />
          Cavalla Academy
        </span>
        <nav aria-label="Academy" className="-mb-px flex min-w-0 items-center gap-5 overflow-x-auto whitespace-nowrap" data-id="element-119" data-mp="167rf5bzd6j5x">
          <NavLink to="/academy" end className={linkClass} data-id="element-120" data-mp="1196ejbg79xgy">
            Courses
          </NavLink>
          <NavLink to="/academy/dashboard" className={linkClass} data-id="element-121" data-mp="3qyi51th32rgc">
            My learning
          </NavLink>
          <NavLink to="/academy/community" className={linkClass} data-id="element-122" data-mp="3lym98hiji6bv">
            Community
          </NavLink>
          {state.learner && <NavLink to="/academy/messages" className={linkClass} data-id="element-123" data-mp="2e082qkkjxupc">
              Messages
              {unreadMessages > 0 && <span className="rounded-full bg-gold px-1.5 text-[11px] font-semibold text-charcoal" aria-label={`${unreadMessages} unread`} data-id="element-124" data-mp="241iy3tho26r1">
                  {unreadMessages}
                </span>}
            </NavLink>}
          <NavLink to="/academy/team" className={linkClass} data-id="element-125" data-mp="1uao1bv6snorc">
            Team
          </NavLink>
          {/* Only signed-in staff ever see a link to the admin area. */}
          {staff && role !== 'learner' && <NavLink to="/academy/admin" className={linkClass} data-id="element-126" data-mp="1lclzxej5eu3j">
              {role === 'instructor' ? 'Instructor' : role === 'moderator' ? 'Moderation' : 'Admin'}
            </NavLink>}
        </nav>
        <div className="ml-auto flex shrink-0 items-center gap-3" data-id="element-127" data-mp="1bexv1vrtw67n">
          {state.learner && <NavLink to="/academy/settings" className="hidden max-w-[16ch] truncate text-small text-muted hover:text-ink lg:block" data-id="element-128" data-mp="1gdiwtzmqaxy7">
              {state.learner.name}
            </NavLink>}
          <NotificationMenu data-id="element-129" data-mp="sqnoip7q48yz" />
        </div>
      </Container>
    </div>;
}